import React from 'react';
import { Typography } from 'antd';
import { formatDate } from 'utilities/datesAndTimes';

const { Text } = Typography;

import { CREDIT_PROTECTION_STATUS } from 'utilities/constants';
import { getCreditProtectionDetails } from 'utilities/helpers';

const CreditProtectionDetails = ({ account }) => {
  const { displayStatus, status, policyInfo } =
    getCreditProtectionDetails(account);

  if (status === CREDIT_PROTECTION_STATUS.NOT_ENROLLED.raw) {
    return displayStatus;
  }

  const dateEnrolledText = `Date Enrolled: ${formatDate(policyInfo?.dateEnrolled)}`;
  const dateStatusEffectiveText = `Date Status Effective: ${formatDate(policyInfo?.dateStatusEffective)}`;

  const PREVIOUSLY_ENROLLED_STATUS = [
    CREDIT_PROTECTION_STATUS.CANCELLED.raw,
    CREDIT_PROTECTION_STATUS.SUSPENDED.raw,
    CREDIT_PROTECTION_STATUS.PENDING.raw,
  ];

  if (PREVIOUSLY_ENROLLED_STATUS.includes(status)) {
    return (
      <>
        <Text strong>{displayStatus}</Text>
        <br />
        {dateEnrolledText}
        <br />
        {dateStatusEffectiveText}
      </>
    );
  }

  if (status === CREDIT_PROTECTION_STATUS.ENROLLED.raw) {
    return (
      <>
        <Text strong>{displayStatus}</Text>
        <br />
        {dateEnrolledText}
      </>
    );
  }
};

export default CreditProtectionDetails;
